import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const AdminAuthPage = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/login`, form);

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("isAdmin", res.data.isAdmin ? "true" : "false");

        if (res.data.isAdmin) {
          toast.success("Admin login successful");
          navigate("/admin/dashboard");
        } else {
          toast.error("Access denied: Not an admin");
        }
      } else {
        toast.error("Invalid server response");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{
        background: "linear-gradient(135deg, #667eea, #764ba2)",
        overflow: "hidden",
      }}
    >
      {/* Glassmorphic Login Card */}
      <div
        className="card shadow-lg p-4 border-0"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "20px",
          background: "rgba(255, 255, 255, 0.15)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          color: "#fff",
        }}
        data-aos="zoom-in"
      >
        <h2 className="text-center mb-4 fw-bold">Admin Login</h2>

        <form onSubmit={handleLogin}>
          {/* Email */}
          <div className="mb-3">
            <input
              type="email"
              name="email"
              placeholder="Enter email"
              value={form.email}
              onChange={handleChange}
              className="form-control rounded-pill px-3 py-2"
              required
            />
          </div>

          {/* Password + Show/Hide */}
          <div className="mb-3 position-relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter password"
              value={form.password}
              onChange={handleChange}
              className="form-control rounded-pill px-3 py-2 pe-5"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-pill px-3"
              style={{ fontSize: "0.8rem" }}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          {/* Submit */}
          <div className="d-grid">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-light rounded-pill fw-bold py-2"
            >
              {loading ? "Processing..." : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminAuthPage;
